import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import ConstitutionBylaws from "../Components/ConstitutionsBylaws/ConstitutionsBylaws";

function ConstBylaws() {
  return (
    <>
      <Navbar />
      <ConstitutionBylaws />
      <Footer />
    </>
  );
}

export default ConstBylaws;
